<template>
	<div class="control-group" :class="{filled: filled, active: focused, error: errors && errors.length > 0, disabled: disabled}">
		<div class="control-holder">
			<label v-if="label" :class="{'has-prepend': prependIcon}">{{ label }}<span v-if="required">*</span></label>
			<div class="input" :class="{'has-append': appendIcon, 'has-prepend': prependIcon}">
				<span v-if="prependIcon" @click.prevent="$emit('click:prepend')" class="prepend-icon">
					<icon :icon="prependIcon"></icon>
				</span>
				<div class="input-holder"><div class="stripe-input" ref="mount"></div></div>
		    	<span v-if="appendIcon" @click.prevent="$emit('click:append', $event)" class="append-icon">
		    		<icon :icon="appendIcon"></icon>
		    	</span>
		    </div>
		</div>
        <transition name="slide-down">
            <div class="error-text" v-if="errors && errors.length > 0">
                <div v-for="error in errors">{{ error }}</div>
            </div>
        </transition>
    </div>
</template>

<script>
	import stripeConfig from '../../config/stripe-config';

	export default {
		props: ['value', 'label', 'errors', 'stripe', 'elements', 'type', 'appendIcon', 'disabled', 'prependIcon', 'required'],
		data() {
			return {
				card: this.value,
				focused: false,
				filled: false
			}
		},
		watch: {
			elements() {
				if(this.elements) {
					this.card = this.elements.create(this.type, {style: stripeConfig.style});
					this.card.mount(this.$refs.mount);
					this.card.on('change', ((event) => {
						this.filled = !event.empty;
					}).bind(this));
					this.card.on('blur', ((event) => {
						this.focused = false;
					}).bind(this));
					this.card.on('focus', ((event) => {
						this.focused = true;
					}).bind(this));
				}
			},
			card() {
				this.$emit('input', this.card);
			},
			value() {
				this.card = this.value;
			}
		}
	}
</script>